import React from "react";
import {
  Box,
  Typography,
  Grid,
  Stack,
} from "@mui/material";
import {
  HelpOutline as HelpIcon,
  TouchAppOutlined as PickStepIcon,
  ConfirmationNumberOutlined as TicketStepIcon,
  VerifiedUserOutlined as FairStepIcon,
  MonetizationOnOutlined as WinStepIcon,
} from "@mui/icons-material";
import { colors, borderRadiusPx } from "../../../../../theme";
import { LOTTERY_NAMES, LOTTERY_TYPES } from "../../../../../static/Constants";

const STEPS = [
  {
    step: "01",
    icon: PickStepIcon,
    title: `Select an Open ${LOTTERY_NAMES.MEGABET} Round`,
    desc: "Browse through live multi-random games created by verified creators with customized matrix sizes and prize pools.",
  },
  {
    step: "02",
    icon: TicketStepIcon,
    title: "Pick Your Number Combination",
    desc: "Select the required quantity of unique numbers from the game board matrix (e.g., 4 numbers from 1 to 20).",
  },
  {
    step: "03",
    icon: FairStepIcon,
    title: "Chainlink VRF Provable Draw",
    desc: "When the round concludes, Chainlink VRF generates cryptographically verifiable on-chain random winning numbers.",
  },
  {
    step: "04",
    icon: WinStepIcon,
    title: "Jackpot Payout or Rollover",
    desc: "Match the winning numbers to receive the jackpot directly to your wallet! If there is no winner, the pot rolls over to multiply the prize.",
  },
];

const MegaHowToPlay = () => {
  const megaTheme = LOTTERY_TYPES[2];

  return (
    <Box sx={{ mt: 6, mb: 4 }}>
      {/* 4 Steps Overview */}
      <Box
        sx={{
          bgcolor: colors.dashboard.cardBg,
          borderRadius: borderRadiusPx.xl,
          border: `1px solid ${colors.dashboard.cardBorder}`,
          p: { xs: 3, md: 4 },
          mb: 3,
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 3 }}>
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: borderRadiusPx.md,
              bgcolor: megaTheme.bgColor,
              color: megaTheme.color,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <HelpIcon sx={{ fontSize: 20 }} />
          </Box>
          <Box>
            <Typography
              variant="h6"
              sx={{ fontWeight: 700, color: colors.slate[900], fontSize: "1.1rem" }}
            >
              {`How Autobet ${LOTTERY_NAMES.MEGABET} Works`}
            </Typography>
            <Typography variant="body2" sx={{ color: colors.slate[500] }}>
              A 4-step decentralized multi-number lottery game
            </Typography>
          </Box>
        </Stack>

        <Grid container spacing={3}>
          {STEPS.map((item, idx) => {
            const StepIcon = item.icon;
            return (
              <Grid item xs={12} sm={6} md={3} key={idx}>
                <Box
                  sx={{
                    p: 2.5,
                    bgcolor: colors.slate[50],
                    borderRadius: borderRadiusPx.lg,
                    border: `1px solid ${colors.slate[200]}`,
                    height: "100%",
                  }}
                >
                  <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1.5 }}>
                    <Box
                      sx={{
                        width: 32,
                        height: 32,
                        borderRadius: borderRadiusPx.md,
                        bgcolor: megaTheme.bgColor,
                        color: megaTheme.darkColor,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <StepIcon sx={{ fontSize: 18 }} />
                    </Box>
                    <Typography
                      variant="caption"
                      sx={{
                        fontWeight: 800,
                        color: megaTheme.color,
                        fontSize: "0.85rem",
                      }}
                    >
                      {item.step}
                    </Typography>
                  </Stack>
                  <Typography
                    variant="subtitle2"
                    sx={{ fontWeight: 700, color: colors.slate[900], mb: 0.5 }}
                  >
                    {item.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: colors.slate[600], fontSize: "0.82rem", lineHeight: 1.5 }}
                  >
                    {item.desc}
                  </Typography>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Box>
  );
};

export default MegaHowToPlay;
